import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "relatedVideo",
  props: {
    relatedList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter();
    /* 视频点击事件 */

    var videoClick = function videoClick(id) {
      router.push("/videodetail/".concat(id));
    };
    /* 歌手点击事件 */


    var artistClick = function artistClick(id) {
      router.push("/main/artistdetail/".concat(id));
    };

    return {
      videoClick: videoClick,
      artistClick: artistClick
    };
  },
  components: {}
});